import { useQuery } from '@tanstack/react-query'

import { fetchCampaignEstimate } from '@/lib/venue/campaignApi'
import type { CampaignEstimateParams } from '@/lib/venue/campaignViewModel'

export function campaignEstimateQueryKey(venueId: string, params: CampaignEstimateParams) {
  return ['venue', venueId, 'campaign-estimate', params] as const
}

/**
 * 작성 화면의 대상 수 미리보기(#714 §1-7) — 대상 조건(`params`)이 바뀔 때만 새로 조회한다(제목·본문
 * 입력은 쿼리 키에 없으므로 재조회를 트리거하지 않는다).
 *
 * 🚨 `enabled=false`로 두면(예: 예약자 대상인데 날짜가 아직 안 채워짐) 이전 결과가 캐시에 남는다 —
 * 호출부가 `estimateParamsReady`로 채워졌는지 먼저 확인하고 이 훅에 넘긴다.
 */
export function useCampaignEstimate(venueId: string, params: CampaignEstimateParams, enabled: boolean) {
  return useQuery({
    queryKey: campaignEstimateQueryKey(venueId, params),
    queryFn: () => fetchCampaignEstimate(venueId, params),
    enabled,
  })
}
